import { defineMessages } from 'react-intl';
var msg = defineMessages({
    customer: { defaultMessage: 'Kunden zuweisen', id: 'customer.menu.headline' },
});
export default msg;
